/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1SchoolsListState = typeof V1SchoolsListState[keyof typeof V1SchoolsListState];


export const V1SchoolsListState = {
  active: 'active',
  all: 'all',
  archived: 'archived',
  deleted: 'deleted',
} as const;
